import { Farm, FarmListRow, FarmListFilter } from '@/api/farms/types';

export interface FarmsState {
  farmsContext: Farm[];
  status: string;
  createStatus: string;
  deleteStatus: string;
  farmListContext: FarmListRow[];
  farmListStatus: string;
  farmListFilter:  FarmListFilter;
}

export const farmListFilter = '_farm_list_filter';